import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { environment } from '../../../environments/environment'
import { IncentiveMode } from '../enums/incentive-mode.enum'
import { TargetApiRoutes } from '../enums/target-api-routes.enum'
import { Environment } from '../interfaces/environment.interface'
import { Theme } from '../interfaces/resources/theme.interface'
import { EnvironmentService } from './environment.service'

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  environment: Environment

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
    this.environmentService.loadEnvironment().subscribe((env) => {
      this.environment = env
    })
  }

  list(params?: { mode?: IncentiveMode }): Promise<Theme[]> {
    return firstValueFrom(
      this.http.get(`${this.environment.apiBaseUrl}${TargetApiRoutes.Themes}`, {
        params
      })
    ).then((themeRes: Object) => {
      return themeRes as Theme[]
    })
  }
}
